import React, {Component} from "react";
import Link from "gatsby-link";
import UserLinks from "../UserLinks/UserLinks";
import ReactMenu from 'react-burger-menu/lib/menus/push';
import MediaQuery from 'react-responsive';
import logo from "../Header/img/logo-is-white.png";
import "./Menu.scss";

let MenuContent = React.createClass({
    render:function () {
        return(
            <div className="d-flex align-content-between flex-wrap">
                <div className="menu">
                    <div className="menu-logo">
                        <img src={logo} alt="Logo INTEGRAL SERVICE" className="img-fluid"/>
                    </div>
                    <ul className="menu-content">
                        <li>
                            <a id="home" className="menu-item" href="/" title="Accueil">Accueil</a>
                        </li>
                        <li>
                            <a id="service" className="menu-item" href="/services" title="Services proposés par Integral Service">Nos services</a>
                        </li>
                        <li>
                            <a id="startup" className="menu-item" href="/startup" title="Une agence Web pour les entrepreneurs">Entrepreneur ?</a>
                        </li>
                        <li>
                            <a id="realisation" className="menu-item" href="/realisation" title="Réalisations web">Réalisations</a>
                        </li>
                        <li>
                            <a id="about" className="menu-item" href="/about" title="A propos">A propos</a>
                        </li>
                        <li>
                            <a id="blog" className="menu-item" href="/blog" title="Blog">Blog</a>
                        </li>
                    </ul>
                </div>
                <div className="adress" >
                    <ul>
                    <li className="contact-us">
                        <a id="contact" className="menu-item" href="/contact" title="Nous Contacter">Nous contacter</a>
                    </li>                    </ul>
                </div>
            </div>
        );

    }
})
var isMenuOpen = function(state) {
    console.log(state);
    return state.isOpen;
};
class Menu extends React.Component {
    showSettings (event) {
        event.preventDefault();
    }


    render () {

        return (

            <div>

                <MediaQuery maxDeviceWidth={1224}>
                    <ReactMenu width="100vw" className="text-center" pageWrapId={"page-wrap"} outerContainerId={"outer-container"}>
                        <MenuContent/>
                    </ ReactMenu>
                </MediaQuery>

                <MediaQuery minDeviceWidth={1224} values={{deviceWidth: 1600}}>
                    <ReactMenu pageWrapId={"page-wrap"} outerContainerId={"outer-container"} >
                        <MenuContent/>
                    </ ReactMenu>
                </MediaQuery>
            </div>

        );
    }
}
export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx